<template lang="pug">
  #question-preview-answer
    .block.px-2(v-if="type === 'text'")
      span.has-text-grey Free text answer field
    .block(v-else)
      WtButton(
        semibold
        color="primary"
        size="normal"
        isText
        :isRouterLink="false"
        @click.native="expand = !expand"
      ) {{ expand ? "Hide Answers" : "Show Answers" }}
        BIcon(:icon="expand ? 'chevron-up mdi-24px' : 'chevron-down mdi-24px'" class="ml-1")
      .mt-1.px-2(v-show="expand")
        div(v-for="item of getArray")
          span.has-text-grey {{ getAnswerValue(item) }}
          span.has-text-green.pl-2(v-if="item.value === 'right' || isCorrectAnswer(item.value)") &#10003;
          span.has-text-green.pl-2(v-if="type === 'range' && correctAnswer") ({{correctAnswer}}) &#10003;


</template>

<script>
import { questionMixin } from "@/mixins/questionMixin";
import WtButton from "@@/WtButton/WtButton";

export default {
  name: "QuestionViewAnswers",

  components: {
    WtButton
  },

  mixins: [questionMixin],

  props: {
    type: {
      type: String,
      required: true
    },
    answers: {
      type: [String, Object, Array],
      required: true
    },
    correctAnswer: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      expand: false
    };
  },

  computed: {
    getArray() {
      const array = [];
      if (typeof this.answers === "string") {
        const items = this.answers.split("\n##");
        items[0] = items[0].replace("##", "");
        items.forEach((val, index) => {
          array.push({ key: index.toString(), value: val });
        });
      } else {
        if (this.type === "range") {
          array.push({
            key: 0,
            value: `${this.answers.range_start} - ${this.answers.range_end}`
          });
        } else {
          const options = this.answers;
          for (const [key, val] of Object.entries(options)) {
            array.push({ key: key, value: val });
          }
        }
      }
      return array;
    }
  },
  methods: {
    isCorrectAnswer(value) {
      if (this.correctAnswer && this.type === "checkbox") {
        let correctAnswers = this.correctAnswer.split(",");
        correctAnswers = correctAnswers.map(ans => ans.toLowerCase());
        return correctAnswers.includes(value.toLowerCase());
      }
      return !!(
        this.correctAnswer &&
        value.toLowerCase() === this.correctAnswer.toLowerCase()
      );
    }
  }
};
</script>

<style lang="sass" scoped></style>
